// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"styles_modalHeader__24tKw","icon":"styles_icon__3yZ2L"};